<template>
  <div id="kt_app_toolbar" class="app-toolbar py-6 py-lg-6 qbank-section">
    <div
      id="kt_app_toolbar_container"
      class="app-container container-fluid d-flex flex-stack"
    >
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
      >
        <h1
          class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
        >
          {{ $t("common.app_name") }}
        </h1>
        <ul
          class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
        >
          <li class="breadcrumb-item text-muted">
            <a href="#" class="text-muted text-hover-primary">{{
              $t("common.home")
            }}</a>
          </li>
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
          <li class="breadcrumb-item text-muted">
            {{ $t("qbank.create_quiz") }}
          </li>
        </ul>
      </div>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <button
          @click="$router.go(-1)"
          class="btn btn-light"
          style="
            font-weight: 600;
            padding: 8px 20px;
            margin-left: 15px;
            background: #d7d7d745;
          "
        >
          {{ $t("common.back") }}
          <i
            class="fa fa-arrow-right"
            style="color: #07c232; margin-right: 10px"
          ></i>
        </button>
      </div>
    </div>
  </div>
  <div class="container mt-5 qbank-section">
    <div class="card shadow-lg p-4">
      <h2 class="text-center">{{ $t("qbank.create_quiz") }}</h2>
      <hr />
      <ul class="nav nav-pills mb-4">
        <li
          v-for="(step, index) in localizedSteps"
          :key="index"
          class="nav-item"
        >
          <a class="nav-link" :class="{ active: currentStep === index }">
            <i :class="step.icon"></i> {{ step.label }}
          </a>
        </li>
      </ul>

      <form v-if="currentStep === 0" @submit.prevent="submitLessons">
        <h4>{{ $t("qbank.choose_lessons") }}</h4>
        <ul>
          <li v-for="lesson in lessons" :key="lesson.id">
            <div>
              <!-- عنوان الدرس مع سهم التوسيع -->
              <h5
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapseLesson' + lesson.id"
                class="d-flex align-items-center"
              >
                <span
                  :class="{ 'rotate-90': isCollapsed(lesson.id) }"
                  class="me-2"
                >
                  <i class="bi bi-chevron-right"></i>
                </span>

                {{ lesson.name }}
              </h5>

              <!-- Checkbox لتحديد الكل للعناصر المفعلة فقط -->

              <div :id="'collapseLesson' + lesson.id" class="collapse">
                <div class="mb-2">
                  <input
                    type="checkbox"
                    :id="'selectAll-' + lesson.id"
                    @change="toggleSelectAll($event, lesson)"
                  />
                  <small :for="'selectAll-' + lesson.id" class="ms-1">{{
                    $t("qbank.select_all")
                  }}</small>
                </div>
                <ul>
                  <li
                    v-if="lesson.lessons && lesson.lessons.length > 0"
                    v-for="(lessonDetail, index) in lesson.lessons"
                    :key="lessonDetail.id"
                  >
                    <div class="row align-items-center">
                      <!-- Checkbox لاختيار الدرس الفرعي -->
                      <div class="col-auto">
                        <input
                          type="checkbox"
                          v-model="selectedLessonDetails"
                          :value="lessonDetail.id"
                          class="mr-2"
                          :disabled="lessonDetail.questions_count === 0"
                          :class="{
                            'disabled-checkbox':
                              lessonDetail.questions_count === 0,
                          }"
                        />
                      </div>

                      <div class="col">
                        <b
                          :class="{
                            'text-muted': lessonDetail.questions_count === 0,
                          }"
                        >
                          {{ lessonDetail.title }}
                          <span class="text-primary"
                            >({{ lessonDetail.questions_count }}
                            {{ $t("qbank.questions") }})</span
                          >
                        </b>
                      </div>

                      <div class="col-auto">
                        <div class="btn-group" role="group">
                          <button
                            type="button"
                            class="btn btn-secondary btn-sm"
                            @click="decreaseQuestionCount(lesson.id, index)"
                            :disabled="lessonDetail.questions_count === 0"
                            :class="{
                              'disabled-btn':
                                lessonDetail.questions_count === 0,
                            }"
                          >
                            -
                          </button>

                          <input
                            type="number"
                            v-model="lessonDetail.questions_count"
                            readonly
                            class="form-control form-control-sm text-center"
                            style="width: 60px"
                            :class="{
                              'disabled-input':
                                lessonDetail.questions_count === 0,
                            }"
                          />

                          <button
                            type="button"
                            class="btn btn-secondary btn-sm"
                            @click="
                              increaseQuestionCount(
                                lesson.id,
                                index,
                                lessonDetail.max_questions
                              )
                            "
                            :disabled="lessonDetail.questions_count === 0"
                            :class="{
                              'disabled-btn':
                                lessonDetail.questions_count === 0,
                            }"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li v-else>
                    <div class="text-muted">{{ $t("qbank.no_content") }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>

        <hr />

        <div class="d-flex justify-content-between mt-1">
          <button
            disabled="true"
            class="btn btn-light mt-3"
            type="button"
            @click="prevStep"
          >
            <i class="fas fa-arrow-right"></i> {{ $t("common.prev") }}
          </button>
          <button class="btn btn-success mt-3" type="submit">
            {{ $t("common.next") }} <i class="fas fa-arrow-left"></i>
          </button>
        </div>
      </form>

      <!-- نموذج اختيار المصادر -->
      <form v-if="currentStep === 1" @submit.prevent="submitSources">
        <h4>{{ $t("qbank.choose_sources") }}</h4>
        <!-- Checkbox لتحديد الكل -->
        <div class="mb-2">
          <input
            type="checkbox"
            id="selectAllSources"
            @change="toggleSelectAllSources($event)"
          />
          <small for="selectAllSources" class="ms-1">{{
            $t("qbank.select_all")
          }}</small>
        </div>

        <ul>
          <li v-for="source in sources" :key="source.id">
            <div class="row align-items-center mb-3">
              <!-- Checkbox -->
              <div class="col-auto">
                <input
                  type="checkbox"
                  v-model="selectedSources"
                  :value="source.id"
                  class="mr-2"
                  :disabled="source.questions_count === 0"
                  :class="{ 'disabled-checkbox': source.questions_count === 0 }"
                />
              </div>

              <!-- اسم المصدر وعدد الأسئلة -->
              <div class="col">
                <b :class="{ 'text-muted': source.questions_count === 0 }">
                  {{ source.name }}
                  <span class="text-primary"
                    >({{ source.questions_count }}
                    {{ $t("qbank.questions") }})</span
                  >
                </b>
              </div>

              <!-- الأزرار وحقل الإدخال -->
              <div class="col-auto">
                <div class="btn-group" role="group">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="decreaseQuestionCountSource(source.id)"
                    :disabled="source.questions_count === 0"
                  >
                    -
                  </button>

                  <input
                    type="number"
                    v-model="source.questions_count"
                    readonly
                    class="form-control form-control-sm text-center"
                    style="width: 60px"
                  />

                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    @click="
                      increaseQuestionCountSource(
                        source.id,
                        source.max_questions
                      )
                    "
                    :disabled="source.questions_count === 0"
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <hr style="margin-top: 50px" />

        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-light mt-3" type="button" @click="prevStep">
            <i class="fas fa-arrow-right"></i> {{ $t("common.prev") }}
          </button>

          <button class="btn btn-success mt-3" type="submit">
            {{ $t("common.next") }} <i class="fas fa-arrow-left"></i>
          </button>
        </div>
      </form>

      <!-- نموذج عرض الأسئلة مع أزرار الزيادة والنقصان -->
      <form v-if="currentStep === 2" @submit.prevent="submitQuestions">
        <h4>{{ $t("qbank.choose_questions") }}</h4>

        <!-- Switch لاختيار وضع الكويز -->
        <div
          class="form-group p-5"
          style="
            border-radius: 20px;
            background: #dddddd0f !important;
            border: 1px solid #28a745;
            border: 1px solid #f4f4f461;
          "
        >
          <label class="d-block mb-3">{{ $t("qbank.choose_mode") }}</label>
          <div class="btn-group btn-group-toggle w-100" data-toggle="buttons">
            <button
              style="border: 1px solid #07b12c"
              type="button"
              class="btn d-flex justify-content-between align-items-center"
              :class="quizMode === 'timed' ? 'active-mode' : 'inactive-mode'"
              @click="quizMode = 'timed'"
            >
              {{ $t("qbank.mode_timed") }}
              <span v-if="quizMode === 'timed'">✔</span>
            </button>
            <button
              style="border: 1px solid #07b12c"
              type="button"
              class="btn d-flex justify-content-between align-items-center"
              :class="quizMode === 'tutor' ? 'active-mode' : 'inactive-mode'"
              @click="quizMode = 'tutor'"
            >
              {{ $t("qbank.mode_tutor") }}
              <span v-if="quizMode === 'tutor'">✔</span>
            </button>
          </div>
        </div>

        <hr class="text-success" />

        <!-- قائمة الأسئلة -->
        <div>
          <!-- Checkbox لتحديد الكل -->
          <div class="mb-2">
            <input
              type="checkbox"
              id="selectAllQuestionTypes"
              @change="toggleSelectAllQuestionTypes($event)"
            />
            <small for="selectAllQuestionTypes" class="ms-1">{{
              $t("qbank.select_all")
            }}</small>
          </div>

          <ul>
            <li v-for="(question, index) in questionTypes" :key="question.key">
              <div class="row align-items-center mb-3">
                <!-- Checkbox لاختيار النوع -->
                <div class="col-auto">
                  <input
                    type="checkbox"
                    v-model="selectedQuestionTypes"
                    :value="question.key"
                    class="mr-2"
                    :disabled="question.questions_count === 0"
                    :class="{
                      'disabled-checkbox': question.questions_count === 0,
                    }"
                  />
                </div>

                <!-- اسم النوع وعدد الأسئلة -->
                <div class="col">
                  <b :class="{ 'text-muted': question.questions_count === 0 }">
                    {{ translateType(question.key) }}
                    <span class="text-primary"
                      >({{ question.questions_count }}
                      {{ $t("qbank.questions") }})</span
                    >
                  </b>
                </div>

                <!-- أزرار الزيادة والنقصان -->
                <div class="col-auto">
                  <div class="btn-group" role="group">
                    <!-- زر نقصان -->
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      @click="decreaseQuestionCountModes(index)"
                      :disabled="question.questions_count === 0"
                      :class="{
                        'disabled-btn': question.questions_count === 0,
                      }"
                    >
                      -
                    </button>

                    <!-- حقل العدد -->
                    <input
                      type="number"
                      v-model="question.questions_count"
                      readonly
                      class="form-control form-control-sm text-center"
                      style="width: 60px"
                      :class="{
                        'disabled-input': question.questions_count === 0,
                      }"
                    />

                    <!-- زر زيادة -->
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      @click="increaseQuestionCountModes(index)"
                      :disabled="question.questions_count === 0"
                      :class="{
                        'disabled-btn': question.questions_count === 0,
                      }"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <hr style="margin-top: 50px" />

        <div class="d-flex justify-content-between mt-4">
          <button class="btn btn-light mt-3" type="button" @click="prevStep">
            <i class="fas fa-arrow-right"></i> {{ $t("common.prev") }}
          </button>
          <button class="btn btn-success mt-3" type="submit">
            {{ $t("common.next") }} <i class="fas fa-arrow-left"></i>
          </button>
        </div>
      </form>

      <form v-if="currentStep === 3" @submit.prevent="submitDifficultyLevels">
        <h4>{{ $t("qbank.choose_difficulty") }}</h4>
        <div>
          <!-- Checkbox لتحديد الكل -->
          <div class="mb-2">
            <input
              type="checkbox"
              id="selectAllDifficulties"
              @change="toggleSelectAllDifficulties($event)"
            />
            <small for="selectAllDifficulties" class="ms-1">{{
              $t("qbank.select_all")
            }}</small>
          </div>

          <ul>
            <li
              v-for="(difficulty, index) in difficulties"
              :key="difficulty.key"
            >
              <div class="row align-items-center mb-3">
                <!-- Checkbox لاختيار المستوى -->
                <div class="col-auto">
                  <input
                    type="checkbox"
                    v-model="selectedDifficulties"
                    :value="difficulty.key"
                    class="mr-2"
                    :disabled="difficulty.questions_count === 0"
                    :class="{
                      'disabled-checkbox': difficulty.questions_count === 0,
                    }"
                  />
                </div>

                <!-- اسم المستوى وعدد الأسئلة -->
                <div class="col">
                  <b
                    :class="{ 'text-muted': difficulty.questions_count === 0 }"
                  >
                    {{ translateType(difficulty.key) }}
                    <span class="text-primary"
                      >({{ difficulty.questions_count }}
                      {{ $t("qbank.questions") }})</span
                    >
                  </b>
                </div>

                <!-- أزرار الزيادة والنقصان -->
                <div class="col-auto">
                  <div class="btn-group" role="group">
                    <!-- زر نقصان -->
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      @click="decreaseDifficultyCount(index)"
                      :disabled="difficulty.questions_count === 0"
                      :class="{
                        'disabled-btn': difficulty.questions_count === 0,
                      }"
                    >
                      -
                    </button>

                    <!-- حقل العدد -->
                    <input
                      type="number"
                      v-model="difficulty.questions_count"
                      readonly
                      class="form-control form-control-sm text-center"
                      style="width: 60px"
                      :class="{
                        'disabled-input': difficulty.questions_count === 0,
                      }"
                    />

                    <!-- زر زيادة -->
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm"
                      @click="
                        increaseDifficultyCount(index, difficulty.max_questions)
                      "
                      :disabled="difficulty.questions_count === 0"
                      :class="{
                        'disabled-btn': difficulty.questions_count === 0,
                      }"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="d-flex justify-content_between mt-1">
          <button class="btn btn-light mt-3" type="button" @click="prevStep">
            <i class="fas fa-arrow-right"></i> {{ $t("common.prev") }}
          </button>
          <button class="btn btn-success mt-3" type="submit">
            {{ $t("qbank.confirm_and_start") }} <i class="fas fa-check"></i>
          </button>
        </div>
      </form>
    </div>
    <!-- Modal -->
    <!-- Modal 1 -->
    <div
      class="modal fade"
      id="confirmModal"
      tabindex="-1"
      aria-labelledby="reviewModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow-lg border-0">
          <div class="modal-header">
            <h5 class="modal-title" id="reviewModalLabel">
              <i class="fa fa-question-circle me-2"></i
              >{{ $t("qbank.start_here_question") }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-center">
            <img
              src="assets/img/acad-icon.png"
              alt="Logo"
              class="mb-3 rounded-circle"
            />
            <h5 class="mb-3">{{ $t("qbank.select_count") }}</h5>
            <div class="d-grid gap-2">
              <select id="random_count" class="form-select"></select>
            </div>
            <p class="mt-3 text-muted">{{ $t("qbank.you_can_adjust") }}</p>
          </div>
          <div class="modal-footer justify-content-center">
            <button class="btn btn-success w-50" @click="confirmAndSubmit">
              <i class="fa fa-check-circle me-2"></i
              >{{ $t("qbank.confirm_and_start") }}
            </button>
            <button
              class="btn btn-outline-secondary w-50"
              @click="proceedToNextStep"
              data-bs-dismiss="modal"
            >
              {{ $t("qbank.advanced_settings") }}
              <i class="fa fa-arrow_left me-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal 2 -->
    <div
      class="modal fade"
      id="confirmFinalModal"
      tabindex="-1"
      aria-labelledby="confirmFinalModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content shadow-lg border-0">
          <div class="modal-header">
            <h5 class="modal-title" id="confirmFinalModalLabel">
              <i class="fa fa-flag-checkered me-2"></i
              >{{ $t("qbank.reached_end") }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body text-center">
            <img
              src="assets/img/acad-icon.png"
              alt="Logo"
              class="mb-3 rounded-circle"
            />
            <h5 class="mb-3">{{ $t("qbank.select_final_count") }}</h5>
            <div class="d-grid gap-2">
              <select id="random_count_final" class="form-select"></select>
            </div>
            <p class="mt-3 text-muted">
              {{ $t("qbank.you_can_adjust_final") }}
            </p>
          </div>
          <div class="modal-footer justify-content-center">
            <button class="btn btn-primary w-50" @click="submitFinal">
              <i class="fa fa-check-circle me-2"></i
              >{{ $t("qbank.confirm_and_start") }}
            </button>
            <button
              class="btn btn-outline-secondary w-50"
              data-bs-dismiss="modal"
            >
              <i class="fa fa-times-circle me-2"></i>{{ $t("common.cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      token: localStorage.getItem("access_token"),
      currentStep: 0,
      quizMode: "timed", // قيمة وضع الاختبار
      selectedQuestionTypes: [], // لتخزين الأسئلة المختارة
      question_bank_id: 0,
      questionTypes: [],
      difficulties: [],
      selectedLessonDetails: [], // لتخزين الدروس الفرعية المخ
      formData: {
        lessons: [],
        sources: [],
        testType: "",
        difficulty: "",
      },
      selectedDifficulties: [],
      sources: [], // المصادر التي سيتم جلبها
      selectedSources: [], // المصادر التي يتم اختيارها من قبل المستخدم
      lessons: [],
      testModes: [],
      difficultyLevels: [],
      steps: [
        { labelKey: "qbank.choose_lessons", icon: "fas fa-book" },
        { labelKey: "qbank.choose_sources", icon: "fas fa-database" },
        { labelKey: "qbank.choose_questions", icon: "fas fa-list" },
        { labelKey: "qbank.choose_difficulty", icon: "fas fa-tachometer-alt" },
      ],
      subscriptionPlan: this.$route.query.id,
    };
  },
  computed: {
    localizedSteps() {
      return this.steps.map((s) => ({
        icon: s.icon,
        label: this.$t(s.labelKey),
      }));
    },
  },
  methods: {
    isCollapsed(lessonId) {
      // فحص ما إذا كان الـ collapse الخاص بالدرس مفتوحًا أم لا
      return this.$refs["collapseLesson" + lessonId]?.classList.contains(
        "show"
      );
    },
    toggleSelectAllSources(event) {
      const isChecked = event.target.checked;

      this.sources.forEach((source) => {
        if (source.questions_count > 0) {
          if (isChecked && !this.selectedSources.includes(source.id)) {
            this.selectedSources.push(source.id);
          } else if (!isChecked) {
            this.selectedSources = this.selectedSources.filter(
              (id) => id !== source.id
            );
          }
        }
      });
    },
    toggleQuizMode() {
      this.quizMode = this.quizMode === "timed" ? "tuthr" : "timed";
    },
    toggleSelectAllDifficulties(event) {
      const isChecked = event.target.checked;

      if (isChecked) {
        // تحديد كل العناصر المفعلة فقط
        this.selectedDifficulties = this.difficulties
          .filter((difficulty) => difficulty.questions_count > 0)
          .map((difficulty) => difficulty.key);
      } else {
        // إلغاء التحديد بالكامل
        this.selectedDifficulties = [];
      }
    },
    toggleSelectAllQuestionTypes(event) {
      const isChecked = event.target.checked;

      if (isChecked) {
        // إضافة كل العناصر المفعلة إلى الـ Checkbox
        this.selectedQuestionTypes = this.questionTypes
          .filter((question) => question.questions_count > 0)
          .map((question) => question.key);
      } else {
        // إزالة كل العناصر من التحديد
        this.selectedQuestionTypes = [];
      }
    },
    toggleSelectAll(event, lesson) {
      const isChecked = event.target.checked;

      lesson.lessons.forEach((lessonDetail) => {
        if (lessonDetail.questions_count > 0) {
          if (
            isChecked &&
            !this.selectedLessonDetails.includes(lessonDetail.id)
          ) {
            this.selectedLessonDetails.push(lessonDetail.id);
          } else if (
            !isChecked &&
            this.selectedLessonDetails.includes(lessonDetail.id)
          ) {
            this.selectedLessonDetails = this.selectedLessonDetails.filter(
              (id) => id !== lessonDetail.id
            );
          }
        }
      });
    },
    isAllSelected(lesson) {
      // يتأكد أن كل العناصر المفعلة محددة
      const enabledLessons = lesson.lessons.filter(
        (l) => l.questions_count > 0
      );
      return enabledLessons.every((l) =>
        this.selectedLessonDetails.includes(l.id)
      );
    },
    translateType(key) {
      const diffKeys = ["easy", "medium", "hard", "very_hard"];
      if (diffKeys.includes(key)) return this.$t(`qbank.difficulty.${key}`);
      return this.$t(`qbank.type.${key}`);
    },
    async fetchData(endpoint, target, body = null) {
      try {
        const response = await fetch(endpoint, {
          method: body ? "POST" : "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: body ? JSON.stringify(body) : null,
        });
        const data = await response.json();
        if (data && data.data) this[target] = data.data;
        this.lessons.forEach((lesson) => {
          if (lesson.lessons) {
            lesson.lessons.forEach((detail) => {
              detail.max_questions = detail.questions_count; // خزّن نسخة ثابتة من العدد
            });
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    increaseQuestionCount(lessonId, index, max) {
      const lesson = this.lessons.find((l) => l.id === lessonId);
      if (lesson && lesson.lessons[index].questions_count < max) {
        lesson.lessons[index].questions_count++;
      }
    },
    decreaseQuestionCount(lessonId, index) {
      const lesson = this.lessons.find((l) => l.id === lessonId);

      if (lesson && lesson.lessons[index].questions_count > 1) {
        lesson.lessons[index].questions_count--;
      }
    },
    increaseQuestionCountModes(index) {
      const question = this.questionTypes[index];
      if (question && question.questions_count < question.max_questions) {
        question.questions_count++;
      }
    },

    decreaseQuestionCountModes(index) {
      if (this.questionTypes[index].questions_count > 1) {
        this.questionTypes[index].questions_count--;
      }
    },
    increaseDifficultyCount(index, max) {
      const difficulty = this.difficulties[index];
      if (difficulty && difficulty.questions_count < max) {
        difficulty.questions_count++;
      }
    },

    decreaseDifficultyCount(index) {
      const difficulty = this.difficulties[index];
      if (difficulty && difficulty.questions_count > 1) {
        difficulty.questions_count--;
      }
    },
    async submitLessons() {
      try {
        // تجهيز قائمة الدروس المختارة مع عدد الأسئلة
        const selectedLessons = this.lessons.flatMap((lesson) =>
          lesson.lessons
            .filter((detail) =>
              (this.selectedLessonDetails || []).includes(detail.id)
            )
            .map((detail) => ({ id: detail.id, count: detail.questions_count }))
        );
        if (!selectedLessons || selectedLessons.length === 0) {
          Swal.fire({
            title: this.$t("qbank.please_select_lessons"),
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: this.$t("common.ok"),
          });
          return;
        }

        // إرسال البيانات للـ API
        const formData = new FormData();
        selectedLessons.forEach((lesson, index) => {
          formData.append(`lessons[${index}][id]`, lesson.id);
          formData.append(`lessons[${index}][count]`, lesson.count);
        });
        formData.append("subscription_plan_id", this.subscriptionPlan);

        const response = await fetch(`${apiUrl}/qbanks/sources`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`خطأ في الطلب: ${response.status}`);
        }

        const responseData = await response.json();
        this.sources = responseData.data || [];
        this.sources.forEach((source) => {
          source.max_questions = source.questions_count;
        });
        this.question_bank_id = responseData.question_bank_id;

        // الانتقال للخطوة التالية
        this.nextStep();
      } catch (error) {
        console.error("Error submitting lessons:", error);
        Swal.fire({
          title: this.$t("qbank.please_select_lessons"),
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$t("common.ok"),
        });
      }
    },
    async submitSources() {
      try {
        if (!this.selectedSources || this.selectedSources.length === 0) {
          Swal.fire({
            title: this.$t("qbank.please_select_sources"),
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: this.$t("common.ok"),
          });
          return;
        }

        // إرسال البيانات للـ API
        const formData = new FormData();
        this.selectedSources.forEach((sourceId, index) => {
          const source = this.sources.find((s) => s.id === sourceId);
          if (source) {
            formData.append(`sources[${index}][id]`, source.id);
            formData.append(`sources[${index}][count]`, source.questions_count);
          }
        });

        const response = await fetch(
          `${apiUrl}/qbanks/${this.question_bank_id}/question-modes`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error(`خطأ في الطلب: ${response.status}`);
        }

        const responseData = await response.json();
        this.questionTypes = responseData;
        this.questionTypes.forEach((q) => {
          q.max_questions = q.questions_count;
        });

        // الانتقال للخطوة التالية
        this.nextStep();
      } catch (error) {
        console.error("Error submitting sources:", error);
        Swal.fire({
          title: this.$t("common.error"),
          icon: "error",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$t("common.ok"),
        });
      }
    },
    async confirmAndSubmit() {
      try {
        const result = await Swal.fire({
          title: this.$t("qbank.finished"),
          text: this.$t("qbank.click_ok_to_create_quiz"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.ok"),
          cancelButtonText: this.$t("common.cancel"),
        });
        // If user cancelled, stop here
        if (!result.isConfirmed) {
          return;
        }

        // 🔍 جلب قيمة العنصر <select> بعد التأكيد
        const selectElement = document.getElementById("random_count");

        // 🔎 التحقق من وجود العنصر في الـ DOM
        if (!selectElement) {
          console.error("⚠️ لا يمكن العثور على العنصر random_count في الـ DOM");
          return;
        }

        const randomCount = selectElement.value;

        // 1️⃣ إنشاء FormData لإرسالها
        const formData = new FormData();

        // 2️⃣ إضافة المصادر إلى FormData
        this.selectedSources.forEach((sourceId, index) => {
          const source = this.sources.find((s) => s.id === sourceId);
          if (source) {
            formData.append(`sources[${index}][id]`, source.id);
            formData.append(`sources[${index}][count]`, source.questions_count);
          }
        });

        // 3️⃣ إضافة المعلومات الإضافية
        formData.append("generate_bank", true);
        formData.append("random_count", randomCount);

        console.log("✅ البيانات المرسلة للمصادر: ", formData);

        // 4️⃣ إرسال البيانات
        const response = await fetch(
          `${apiUrl}/qbanks/${this.question_bank_id}/question-modes`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
            body: formData,
          }
        );

        if (!response.ok) {
          throw new Error(`خطأ في الطلب: ${response.status}`);
        }

        const responseData = await response.json();
        console.log("✅ تم إرسال البيانات بنجاح:", responseData);

        const test = responseData.question_bank;

        // 🔀 تحديد رابط التحويل بناءً على نوع الاختبار
        let redirectUrl = "";
        if (test.quiz_mode == 1) {
          redirectUrl = `qbank-quiz-tutor?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}&subscriptionId=${this.subscriptionPlan}`;
        } else {
          redirectUrl = `qbank-quiz-timed?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}&subscriptionId=${this.subscriptionPlan}`;
        }

        // ✨ عرض إشعار النجاح مع تحويل بعد انتهاء المؤقت
        Swal.fire({
          title: "تم إنشاء اختبارك بنجاح!",
          text: "نتمنى لك التوفيق، جاري تحويلك للإختبار ...",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = redirectUrl;
        });
      } catch (error) {
        console.error("❌ خطأ أثناء إرسال البيانات:", error.message);
      }
    },

    // في حال اختيار "الخطوة التالية" فقط
    async proceedToNextStep() {
      // 1️⃣ إنشاء FormData لإرسالها
      const formData = new FormData();

      // 2️⃣ إضافة المصادر إلى FormData
      this.selectedSources.forEach((sourceId, index) => {
        const source = this.sources.find((s) => s.id === sourceId);
        if (source) {
          formData.append(`sources[${index}][id]`, source.id);
          formData.append(`sources[${index}][count]`, source.questions_count);
        }
      });
      // 4️⃣ إرسال البيانات
      const response = await fetch(
        `${apiUrl}/qbanks/${this.question_bank_id}/question-modes`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`خطأ في الطلب: ${response.status}`);
      }
      const responseData = await response.json();
      console.log("تم إرسال البيانات بنجاح:", responseData);
      this.questionTypes = responseData;
      this.questionTypes.forEach((q) => {
        q.max_questions = q.questions_count;
      });
      this.nextStep();
    },

    nextStep() {
      this.currentStep++;
    },
    async submitQuestions() {
      try {
        // تجهيز البيانات لإرسالها بالهيكلية الجديدة
        const payload = {
          question_modes: this.questionTypes
            .filter((question) =>
              this.selectedQuestionTypes.includes(question.key)
            ) // إرسال الأسئلة التي تم اختيارها فقط
            .map((question) => ({
              key: question.key,
              count: question.questions_count,
            })),
          quiz_mode: this.quizMode, // إرسال الوضع الحالي
        };

        if (
          !this.selectedQuestionTypes ||
          this.selectedQuestionTypes.length === 0
        ) {
          Swal.fire({
            title: "الرجاء إختيار نوع الأسئلة",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "موافق",
          });
          return;
        }
        console.log("البيانات المرسلة للأسئلة: ", payload);

        // إرسال البيانات باستخدام fetch
        const response = await fetch(
          `${apiUrl}/qbanks/${this.question_bank_id}/difficulty-levels`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        if (!response.ok) {
          throw new Error(`خطأ في الطلب: ${response.status}`);
        }

        const responseData = await response.json();
        console.log("تم إرسال البيانات بنجاح:", responseData);
        this.difficulties = responseData;
        this.difficulties.forEach((difficultie) => {
          difficultie.max_questions = difficultie.questions_count;
        });

        // الانتقال إلى الخطوة التالية
        this.nextStep();
      } catch (error) {
        Swal.fire({
          title: "الرجاء إختيار نوع الأسئلة",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "موافق",
        });
      }
    },

    async submitDifficultyLevels() {
      try {
        if (this.selectedDifficulties.length === 0) {
          Swal.fire({
            title: "الرجاء إختيار  مستوى الصعوبة",
            icon: "warning",
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "موافق",
          });
          return;
        }

        // 2️⃣ حساب مجموع الأسئلة في كل مستوى صعوبة
        this.maxRandomCount = this.selectedDifficulties.reduce(
          (sum, difficultyKey) => {
            const difficulty = this.difficulties.find(
              (d) => d.key === difficultyKey
            );
            // ✅ التحقق من وجود العنصر قبل استخدامه
            return difficulty && difficulty.questions_count
              ? sum + parseInt(difficulty.questions_count, 10)
              : sum;
          },
          0
        );

        // 3️⃣ تعبئة الخيارات في الـ <select> مع التحقق من وجوده في DOM
        const select = document.getElementById("random_count_final");
        if (!select) {
          console.error("⚠️ العنصر random_count غير موجود في الـ DOM");
          return;
        }
        setTimeout(() => {
          select.innerHTML = "";
          for (let i = 1; i <= this.maxRandomCount; i++) {
            const option = document.createElement("option");
            option.value = i;
            option.textContent = i;
            select.appendChild(option);
          }

          // ✅ تعيين آخر قيمة كـ "محدد" (selected)
          select.value = this.maxRandomCount;
        }, 500);
        const modal = new bootstrap.Modal(
          document.getElementById("confirmFinalModal")
        );
        modal.show();
      } catch (error) {
        console.error("خطأ أثناء إرسال البيانات:", error.message);
        Swal.fire({
          title: "الرجاء إختيار  مستوى الصعوبة",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "موافق",
        });
      }
    },

    async submitFinal() {
      // تجهيز البيانات للإرسال

      const selectElement = document.getElementById("random_count_final");

      // 🔍 التحقق من وجود العنصر أولاً
      if (!selectElement) {
        console.error(
          "⚠️ لا يمكن العثور على العنصر random_count_final في الـ DOM"
        );
        return;
      }

      const randomCount = selectElement.value;

      // ✅ إنشاء الـ payload مع إضافة random_count
      const payload = {
        difficulty_levels: this.difficulties
          .filter((difficulty) =>
            this.selectedDifficulties.includes(difficulty.key)
          )
          .map((difficulty) => ({
            key: difficulty.key,
            count: difficulty.questions_count,
          })),
        random_count: randomCount, // تم إضافتها هنا
      };
      // إرسال البيانات باستخدام fetch
      const response = await fetch(
        `${apiUrl}/qbanks/${this.question_bank_id}/generate-bank`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`خطأ في الطلب: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("تم إرسال البيانات بنجاح:", responseData);

      const test = responseData.question_bank;

      let redirectUrl = "";
      if (test.quiz_mode == 1) {
        redirectUrl = `qbank-quiz-tutor?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}&subscriptionId=${this.subscriptionPlan}`;
      } else {
        redirectUrl = `qbank-quiz-timed?qref=${test.id}&num=${test.answered_questions_count}&mode=${test.quiz_mode}&total=${test.total_questions_count}&subscriptionId=${this.subscriptionPlan}`;
      }

      // عرض إشعار نجاح مع تحويل بعده مباشرة
      Swal.fire({
        title: "تم إنشاء اختبارك بنجاح!",
        text: "نتمنى لك التوفيق ، جاري تحويلك للإختبار ...",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        window.location.href = redirectUrl;
      });
    },
    nextStep() {
      this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 0) this.currentStep--;
    },
  },
  mounted() {
    this.fetchData(
      `${apiUrl}/qbanks/subscription-plans/${this.subscriptionPlan}/child-categories`,
      "lessons"
    );
  },
};
</script>

<style scoped>
.nav-pills .nav-link {
  cursor: pointer;
  font-size: 1.1rem;
}

.card {
  border-radius: 10px;
}

/* تحسين شكل الكارد */
.card {
  border-radius: 15px;
  border: none;
}

/* تحسين عناوين النماذج */
h3,
h4,
h5 {
  font-weight: bold;
}

/* تحسين قائمة الخطوات */
.nav-pills .nav-link {
  border-radius: 10px;
  color: #495057;
  font-weight: bold;
  transition: 0.3s;
}

.nav-pills .nav-link.active {
  background-color: #00c444;
  color: white;
}

/* تحسين شكل الـ Checkbox */
input[type="checkbox"] {
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #28a745;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  transition: 0.2s;
}

input[type="checkbox"]:checked {
  background-color: #00c444;
  border: 2px solid #00c444;
}

input[type="checkbox"]:checked::after {
  content: "✔";
  color: white;
  font-size: 14px;
  position: absolute;
  top: -2px;
  left: 2px;
  font-weight: bold;
}

/* تحسين الأزرار */
.btn {
  border-radius: 8px;
  transition: 0.3s;
}

.btn-primary,
.btn-success {
  background-color: #00c444;
  border-color: #28a745;
}

.btn-primary:hover {
  background-color: #218838 !important;
}

.btn-secondary {
  margin-right: 5px;
  color: #fff;
  background-color: #00c444;
  border-color: #00c444;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

/* تحسين إدخال الأرقام */
input[type="number"] {
  color: #3a3a3a;
  background: #f0f8ff38 !important;
  text-align: center;
  font-weight: bold;
  border: 1px solid #00c444;
  border-radius: 5px;
}

/* تحسين تخطيط القائمة */
form ul {
  list-style: none;
  padding: 0;
}

/* تحسين شريط الخطوات */
.nav.nav-pills {
  display: flex !important;
  flex-wrap: wrap;
  gap: 10px;
  padding: 15px;
  background: linear-gradient(135deg, #f8fffe 0%, #f0fdf4 100%);
  border-radius: 12px;
  margin-bottom: 25px !important;
  border: 1px solid rgba(0, 196, 68, 0.15);
}

.nav.nav-pills .nav-item {
  padding: 0;
  background-color: transparent;
  border-radius: 10px;
}

.nav.nav-pills .nav-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  color: #64748b;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.nav.nav-pills .nav-link i {
  font-size: 1rem;
}

.nav.nav-pills .nav-link.active {
  background: linear-gradient(135deg, #00c744 0%, #00a83b 100%);
  border-color: #00c744;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 199, 68, 0.3);
}

.nav.nav-pills .nav-link:not(.active):hover {
  border-color: #00c744;
  color: #00c744;
}

form li {
  border: 1px solid #00cd4769;
  margin-bottom: 10px;
  padding: 10px;
  background: #f1f3f51f;
  border-radius: 10px;
}

form li ul li {
  font-weight: 700;
  background: #1e1e2d00;
}

/* تحسين مظهر التفاعل */
.d-flex {
  align-items: center;
}

/* تغيير مظهر العناصر غير المفعلة */
.disabled-checkbox {
  cursor: not-allowed;
  opacity: 0.6;
}

.disabled-btn {
  cursor: not-allowed;
  opacity: 0.6;
}

.disabled-input {
  background-color: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.6;
}

.text-muted {
  color: #6c757d;
  /* تعديل اللون ليبدو باهتًا */
}

.active-mode {
  background-color: #07b12c;
  color: white;
  border: 1px solid #07b12c;
}

.inactive-mode {
  background-color: white;
  color: #07b12c;
  border: 1px solid #07b12c;
}

.btn-group .btn {
  flex: 1;
  border-radius: 10px !important;
  margin: 0 5px;
  transition: all 0.3s ease-in-out;
  font-weight: bold;
}

ul .btn {
  margin: 5px !important;
}
</style>
